/**
 * SCRIPT INJECTION FOR LOYALTY PAGES
 *
 * Poligon Central location:
 * "System" -> Script Injection
 */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'loyaltyHtmlHeadInjection',
  initialState: null as null | string,
  reducers: {
    setLoyaltyHtmlHeadInjection(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setLoyaltyHtmlHeadInjection } = slice.actions;

export default slice.reducer;
